var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"80px 0","text-align":"center"}},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("页面不存在")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/home')}}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }